import React from 'react';
import HeaderThin from 'app/components/layout/HeaderThin';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import base64 from 'base-64';

import TeamMembersTable from 'app/components/teamMembers/TeamMembersTable';

import * as teamMembersActions from 'app/ducks/teamMembers/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as teamMembersSelectors from 'app/ducks/teamMembers/selectors';

function selector(state) {
  return {
    teamMembers: teamMembersSelectors.getTeamMembers(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  teamMembersActions,
);
interface ITeamMembersListProps {
  actions: any;
  teamMembers: any;
  match: any;
  appReady: boolean;
}
@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class TeamMembersList extends React.Component<ITeamMembersListProps> {
  static defaultProps: ITeamMembersListProps = {
    actions: undefined,
    teamMembers: undefined,
    match: undefined,
    appReady: false,
  };

  // componentDidMount(): void {
  //   this.props.actions.getAllTeamMembers();
  // }

  render(): React.ReactNode {
    const filterConfig = this.props.match?.params?.filterConfig ? JSON.parse(base64.decode(this.props.match?.params?.filterConfig)) : undefined;
    const counterText = this.props.teamMembers.pagination.meta.totalCount === 1 ? '1 team member' : `${this.props.teamMembers.pagination.meta.totalCount || 0} team members`;

    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              title="Team Members"
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <TeamMembersTable
              {...this.props.teamMembers}
              appReady={this.props.appReady}
              match={this.props.match}
              actions={this.props.actions}
              saveFilters
              showChildren
              counterText={counterText}
              isLoading={this.props.teamMembers.isLoading}
              initialFilterConfig={filterConfig}
              selectTeamMember={this.props.actions.selectTeamMember}
            />
          </div>
        </div>
      </div>
    );
  }
}
